import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'

export const useStyles = makeStyles((theme) => ({
  slide: {
    /* height: '100%',
    alignSelf: 'flex-start',
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
    } */
  },
  formTile: {
    color: theme.palette.secondary.main,
    textTransform: 'capitalize',
    fontWeight: 'bold',
    marginBottom: '1.76vh',
    textAlign: 'left',
    fontSize: 'clamp(1.625em, 2em, 2em)',   
  },
  formSubtitle: {
    color: theme.palette.dark,
    fontWeight: '500',
    fontSize: 'clamp(0.9em, 2em, 1.1em)',
    [theme.breakpoints.down('xl')]: {
      fontSize: 'clamp(0.9em, 2em, 1em)',
    },
    textAlign: 'left',
  },
  logo: {
    [theme.breakpoints.up('md')]: {
      width: '16vw !important',
    },
    [theme.breakpoints.down('md')]: {
      width: '22vw !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '45vw !important',
    },
  },
}))

export const LeftColumn = styled(Grid)(({ theme, imagebg, bgx, bgy, bgw, bgh }) => ({
  backgroundImage: `linear-gradient(180deg, #00000000, #1A27374A), url('${imagebg}')`,
  backgroundSize: bgw && bgh ? `${bgw} ${bgh}` : 'cover',
  backgroundPositionX: bgx ? bgx : 'inherit',
  backgroundPositionY: bgy ? bgy : 'inherit',
  padding: theme.spacing(4),
  display: 'flex',
  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(4),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down('lg')]: {
    backgroundImage: `linear-gradient(180deg, #00000052, #1a2737c2), url('${imagebg}')`,
    minHeight: '35vh',
    maxHeight: '35vh'
  },
  [theme.breakpoints.down('md')]: {
    minHeight: '50vh',
    maxHeight: '50vh'
  }
}))

export const RightColumn = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('xl')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(12),
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(18),
  },
}))
